interface ErrorMap {
    code:string,
    msg:string,
}

export const ERROR_NETWORK_EXCEPTION = 'Failed to fetch dynamically imported module';
export const ERROR_NETWORK_TIMEOUT = 'Error: timeout of';

export const ERROR_MAP_LIST:Array<ErrorMap> = [
    {code:ERROR_NETWORK_EXCEPTION,msg:'系统升级维护中，请稍后刷新页面访问！'},
    {code:ERROR_NETWORK_TIMEOUT,msg:'请求服务器超时，请重新尝试！'},
]

export default {
    ERROR_NETWORK_EXCEPTION
}